import { get, getRawValue } from '../../utils/get';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { IDENTIFIERS } from '../../types/Identifiers';
import { getKeys as _getKeys } from '../../adapters/utils';
var IDs = {
  SITE_NAME: 'site.name',
  SITE_URL: 'site.url',
  BUSINESS_NAME: 'site.business.name',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  ID: 'product.id',
  SKU: 'product.sku',
  NAME: 'product.name',
  DESCRIPTION: 'product.description',
  PRICE: 'product.price',
  CURRENCY: 'product.currency',
  TYPE: 'product.type',
  WEIGHT: 'product.weight',
  AVAILABILITY_SCHEMA: 'product.availability.schema',
  AVAILABILITY_META_TAG: 'product.availability.metaTag',
  SLUG: 'product.slug',
  IMAGE_URL: 'product.image.url',
  IMAGE_WIDTH: 'product.image.width',
  IMAGE_HEIGHT: 'product.image.height',
  IMAGE_ALT: 'product.image.alt',
  THUMBNAIL_URL: 'product.thumbnail.url',
  THUMBNAIL_WIDTH: 'product.thumbnail.width',
  THUMBNAIL_HEIGHT: 'product.thumbnail.height',
  THUMBNAIL_ALT: 'product.thumbnail.alt',
  PRODUCT_PAGE_URL: 'product.url',
  PRODUCT_PAGE_BASE_URL: 'product.baseUrl'
};
var userVisible = [IDs.SITE_NAME, IDs.SKU, IDs.NAME, IDs.DESCRIPTION, IDs.PRICE, IDs.CURRENCY, IDs.AVAILABILITY_META_TAG, IDs.PRODUCT_PAGE_URL, IDs.IMAGE_URL];
export default {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME), _ref[IDs.SITE_URL] = get(item, "context." + CONTEXT_PROPS.SITE_URL), _ref[IDs.BUSINESS_NAME] = get(item, "context." + CONTEXT_PROPS.BUSINESS_NAME), _ref[IDs.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.ID] = get(item, 'product.id'), _ref[IDs.SKU] = get(item, 'product.sku'), _ref[IDs.NAME] = get(item, 'product.name'), _ref[IDs.DESCRIPTION] = get(item, 'product.description'), _ref[IDs.PRICE] = get(item, 'product.price.discountedPrice') > 0 ? "" + get(item, 'product.price.discountedPrice') : "" + get(item, 'product.price.price'), _ref[IDs.CURRENCY] = "" + get(item, 'product.price.currency'), _ref[IDs.TYPE] = get(item, 'product.productType'), _ref[IDs.WEIGHT] = get(item, 'product.weight'), _ref[IDs.AVAILABILITY_SCHEMA] = "" + get(item, 'product.stock.inStock') === 'true' ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock', _ref[IDs.AVAILABILITY_META_TAG] = "" + get(item, 'product.stock.inStock') === 'true' ? 'InStock' : 'out of stock', _ref[IDs.SLUG] = get(item, 'product.slug'), _ref[IDs.IMAGE_URL] = get(item, 'product.media.mainMedia.image.url'), _ref[IDs.IMAGE_WIDTH] = get(item, 'product.media.mainMedia.image.width'), _ref[IDs.IMAGE_HEIGHT] = get(item, 'product.media.mainMedia.image.height'), _ref[IDs.IMAGE_ALT] = get(item, 'product.media.mainMedia.image.alt'), _ref[IDs.THUMBNAIL_URL] = get(item, 'product.media.mainMedia.thumbnail.url'), _ref[IDs.THUMBNAIL_WIDTH] = get(item, 'product.media.mainMedia.thumbnail.width'), _ref[IDs.THUMBNAIL_HEIGHT] = get(item, 'product.media.mainMedia.thumbnail.height'), _ref[IDs.THUMBNAIL_ALT] = get(item, 'product.media.mainMedia.thumbnail.alt'), _ref[IDs.PRODUCT_PAGE_URL] = get(item, 'product.productPageUrl.path'), _ref[IDs.PRODUCT_PAGE_BASE_URL] = get(item, 'product.productPageUrl.base'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob(item) {
    var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
    tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
    return {
      tags: tags
    };
  },
  getBiData: function getBiData(item) {
    return {
      id: get(item, 'product.id'),
      name: get(item, 'product.name')
    };
  },
  getKeys: function getKeys() {
    return _getKeys(IDs, userVisible);
  },
  getSlug: function getSlug(item) {
    return get(item, 'product.slug');
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(itemData, slugValue) {
    var productPageBaseUrl = get(itemData, 'product.productPageUrl.base');

    if (productPageBaseUrl !== '') {
      var updatedItemData = Object.assign({}, itemData);
      updatedItemData.product.productPageUrl.path = productPageBaseUrl + "/" + slugValue;

      if (get(updatedItemData, 'product.slug') !== '') {
        updatedItemData.product.slug = slugValue;
      }

      return updatedItemData;
    }

    return itemData;
  }
};